// extracted by mini-css-extract-plugin
export default {"subheader":"keSthBB0X8sXPY7Ubif8v"};